<template>
  <div class="buttonlist">
    <div class="buttonlist-m">
      <el-form :inline="true" :model="filteForm" class="toolbar" @submit.native.prevent>
        <el-form-item label="监控日期">
          <el-date-picker v-model="filteForm.scheduledDate" type="date" value-format="yyyy-MM-dd" @change="loadData" />
        </el-form-item>
        <el-form-item label="护理组">
          <el-select v-model="filteForm.nursingGroupId" clearable placeholder="全部" style="width:160px" @change="loadData">
            <el-option v-for="g in groupList" :key="g.id" :label="g.name" :value="g.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="关键词">
          <el-input v-model.trim="filteForm.oldmanNameKeyword" placeholder="老人/床位" clearable @keyup.enter.native="loadData" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" plain icon="el-icon-search" @click="loadData">查询</el-button>
          <el-button type="info" plain icon="el-icon-download" @click="exportExcel">导出</el-button>
        </el-form-item>
      </el-form>
      <el-row :gutter="12" class="stats-row">
        <el-col :span="4" v-for="item in statCards" :key="item.label">
          <el-card shadow="hover" :body-style="{ padding: '12px' }">
            <div class="stat-label">{{ item.label }}</div>
            <div class="stat-num" :style="{ color: item.color }">{{ item.value }}</div>
          </el-card>
        </el-col>
      </el-row>
      <div v-loading="loading" style="margin-top:12px">
        <el-table :data="dataList" :row-style="rowStyle" :header-cell-style="headerStyle">
          <el-table-column label="计划时间" width="100" align="center">
            <template slot-scope="s">{{ s.row.scheduledDate }} {{ s.row.scheduledTime }}</template>
          </el-table-column>
          <el-table-column label="老人" prop="oldmanName" width="90" align="center" />
          <el-table-column label="床位" prop="bedNo" width="80" align="center" />
          <el-table-column label="项目" prop="projectName" align="center" />
          <el-table-column label="护工" prop="assignedNurseName" width="90" align="center" />
          <el-table-column label="状态" width="90" align="center">
            <template slot-scope="s">
              <span :style="{ color: statusColor(s.row.status), fontWeight: 600 }">{{ statusText(s.row.status) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="180" align="center">
            <template slot-scope="s">
              <!-- 待执行 → 可开始 -->
              <el-button v-if="s.row.status === 0" type="primary" size="mini" plain
                @click="handleStart(s.row)">开始执行</el-button>
              <!-- 执行中 → 可完成 -->
              <el-button v-if="s.row.status === 1" type="success" size="mini" plain
                @click="handleComplete(s.row)">完成</el-button>
              <!-- 已超时 → 可关闭（填写原因） -->
              <el-button v-if="s.row.status === 3" type="warning" size="mini" plain
                @click="handleCloseTimeout(s.row)">关闭超时</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="total, prev, pager, next" :total="total" :current-page.sync="filteForm.pageNum"
          @current-change="loadData" align="center" class="fenye" />
      </div>

      <!-- 开始执行弹窗 -->
      <el-dialog title="开始执行" :visible.sync="startDialogVisible" width="500px"
        :close-on-click-modal="false" append-to-body @close="resetStartForm">
        <el-form :model="startForm" label-width="80px" size="small">
          <el-form-item label="备注">
            <el-input v-model.trim="startForm.remark" type="textarea" :rows="3" placeholder="请输入备注（选填）" />
          </el-form-item>
          <el-form-item label="图片">
            <div class="upload-area">
              <div v-for="(img, idx) in startForm.images" :key="idx" class="img-item">
                <img :src="img" class="preview-img" />
                <i class="el-icon-close img-del" @click="removeImage('start', idx)"></i>
              </div>
              <div v-if="startForm.images.length < 3" class="upload-btn" @click="triggerUpload('start')">
                <i class="el-icon-plus" style="font-size:24px;color:#999"></i>
                <div style="font-size:12px;color:#999;margin-top:4px">添加图片</div>
              </div>
            </div>
            <div style="font-size:12px;color:#999;margin-top:4px">最多3张，支持 jpg/png/gif，单张不超过10MB</div>
          </el-form-item>
        </el-form>
        <div slot="footer" align="center">
          <el-button @click="startDialogVisible = false">取 消</el-button>
          <el-button type="primary" :loading="startLoading" @click="submitStart">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 完成执行弹窗 -->
      <el-dialog title="完成执行" :visible.sync="completeDialogVisible" width="500px"
        :close-on-click-modal="false" append-to-body @close="resetCompleteForm">
        <el-form :model="completeForm" label-width="80px" size="small">
          <el-form-item label="备注">
            <el-input v-model.trim="completeForm.remark" type="textarea" :rows="3" placeholder="请输入备注（选填）" />
          </el-form-item>
          <el-form-item label="图片">
            <div class="upload-area">
              <div v-for="(img, idx) in completeForm.images" :key="idx" class="img-item">
                <img :src="img" class="preview-img" />
                <i class="el-icon-close img-del" @click="removeImage('complete', idx)"></i>
              </div>
              <div v-if="completeForm.images.length < 3" class="upload-btn" @click="triggerUpload('complete')">
                <i class="el-icon-plus" style="font-size:24px;color:#999"></i>
                <div style="font-size:12px;color:#999;margin-top:4px">添加图片</div>
              </div>
            </div>
            <div style="font-size:12px;color:#999;margin-top:4px">最多3张，支持 jpg/png/gif，单张不超过10MB</div>
          </el-form-item>
        </el-form>
        <div slot="footer" align="center">
          <el-button @click="completeDialogVisible = false">取 消</el-button>
          <el-button type="primary" :loading="completeLoading" @click="submitComplete">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 共用图片上传 input -->
      <input ref="imgInput" type="file" accept="image/*" style="display:none" @change="handleImageSelect" />
    </div>
  </div>
</template>
<script>
import { postDownload } from "@/utils/request.js";
export default {
  name: "NursingTaskMonitor",
  data() {
    const today = new Date();
    const d = today.getFullYear() + "-" + String(today.getMonth() + 1).padStart(2, "0") + "-" + String(today.getDate()).padStart(2, "0");
    return {
      filteForm: { scheduledDate: d, nursingGroupId: null, oldmanNameKeyword: "", pageNum: 1, pageSize: 20 },
      dataList: [],
      total: 0,
      stats: {},
      groupList: [],
      loading: false,
      timer: null,
      // 开始执行弹窗
      startDialogVisible: false,
      startLoading: false,
      startCurrentRow: null,
      startForm: { remark: "", images: [] },
      // 完成执行弹窗
      completeDialogVisible: false,
      completeLoading: false,
      completeCurrentRow: null,
      completeForm: { remark: "", images: [] },
      // 当前激活的上传目标（start / complete）
      activeDialog: "start"
    };
  },
  computed: {
    statCards() {
      const s = this.stats || {};
      return [
        { label: "总数", value: s.total || 0, color: "#333" },
        { label: "待执行", value: s.pending || 0, color: "#1890FF" },
        { label: "执行中", value: s.running || 0, color: "#FF7A45" },
        { label: "已完成", value: s.completed || 0, color: "#52C41A" },
        { label: "超时", value: s.timeout || 0, color: "#F5222D" }
      ];
    }
  },
  methods: {
    loadData() {
      this.loading = true;
      this.$postJson("omc/nursingTask/monitorQuery", this.filteForm).then(res => {
        this.loading = false;
        if (res.code == 200 && res.result) {
          this.stats = res.result.stats || {};
          const tasks = res.result.tasks || {};
          this.dataList = tasks.list || [];
          this.total = tasks.total || 0;
        }
      }).catch(() => { this.loading = false; });
    },
    exportExcel() { postDownload("omc/nursingTask/export", "护理任务.xls", this.filteForm); },
    statusText(s) { return ["待执行", "执行中", "已完成", "已超时", "已取消"][s] || ""; },
    statusColor(s) { return ["#1890FF", "#FF7A45", "#52C41A", "#F5222D", "#8C8C8C"][s] || "#333"; },
    rowStyle() { return "font-size:14px"; },
    headerStyle({ rowIndex }) { if (rowIndex === 0) return "background:#d4f5fa;font-weight:600"; },
    loadGroups() {
      this.$postJson("omc/group/selectShowAll", {}).then(res => { this.groupList = res.result || []; });
    },
    // 开始执行 → 打开弹窗
    handleStart(row) {
      this.startCurrentRow = row;
      this.startForm = { remark: "", images: [] };
      this.startDialogVisible = true;
    },
    resetStartForm() {
      this.startForm = { remark: "", images: [] };
      this.startCurrentRow = null;
      if (this.$refs.imgInput) this.$refs.imgInput.value = "";
    },
    triggerUpload(dialog) {
      this.activeDialog = dialog;
      this.$refs.imgInput.click();
    },
    handleImageSelect(e) {
      const file = e.target.files && e.target.files[0];
      if (!file) return;
      const form = this.activeDialog === "complete" ? this.completeForm : this.startForm;
      if (form.images.length >= 3) { this.$message.warning("最多上传3张图片"); return; }
      const formData = new FormData();
      formData.append("file", file);
      this.$postFormData("dmc/file/uploadFile", formData).then(res => {
        if (res && res.code == 200) {
          form.images.push(res.result);
        } else {
          this.$message.error((res && res.message) || "图片上传失败");
        }
      }).catch(() => { this.$message.error("图片上传失败"); });
      if (this.$refs.imgInput) this.$refs.imgInput.value = "";
    },
    removeImage(dialog, idx) {
      const form = dialog === "complete" ? this.completeForm : this.startForm;
      form.images.splice(idx, 1);
    },
    submitStart() {
      if (!this.startCurrentRow) return;
      this.startLoading = true;
      this.$postJson("omc/nursingTask/start", { id: this.startCurrentRow.id }).then(res => {
        if (res && res.code == 200) {
          this.$message.success("已开始执行");
          this.startDialogVisible = false;
          this.loadData();
        } else {
          this.$message.error((res && res.message) || "操作失败");
        }
      }).finally(() => { this.startLoading = false; });
    },
    // 完成执行 → 打开弹窗
    handleComplete(row) {
      this.completeCurrentRow = row;
      this.completeForm = { remark: "", images: [] };
      this.completeDialogVisible = true;
    },
    resetCompleteForm() {
      this.completeForm = { remark: "", images: [] };
      this.completeCurrentRow = null;
    },
    submitComplete() {
      if (!this.completeCurrentRow) return;
      this.completeLoading = true;
      const photoUrls = this.completeForm.images.join(",");
      this.$postJson("omc/nursingTask/complete", {
        taskId: this.completeCurrentRow.id,
        remark: this.completeForm.remark || "",
        photoUrls: photoUrls || undefined
      }).then(res => {
        if (res && res.code == 200) {
          this.$message.success("任务已完成");
          this.completeDialogVisible = false;
          this.loadData();
        } else {
          this.$message.error((res && res.message) || "操作失败");
        }
      }).finally(() => { this.completeLoading = false; });
    },
    // 关闭超时任务
    handleCloseTimeout(row) {
      this.$prompt("请输入超时原因", "关闭超时任务", {
        confirmButtonText: "确定", cancelButtonText: "取消",
        inputPlaceholder: "请填写超时原因", inputValidator: v => v ? true : "超时原因不能为空"
      }).then(({ value }) => {
        this.$postJson("omc/nursingTask/closeTimeout", { taskId: row.id, timeoutReason: value }).then(res => {
          if (res && res.code == 200) {
            this.$message.success("超时任务已关闭");
            this.loadData();
          } else {
            this.$message.error((res && res.message) || "操作失败");
          }
        });
      }).catch(() => {});
    }
  },
  mounted() {
    this.loadGroups();
    this.loadData();
    this.timer = setInterval(() => this.loadData(), 30000);
  },
  beforeDestroy() { if (this.timer) clearInterval(this.timer); }
};
</script>
<style scoped>
.stats-row { margin-bottom: 8px; }
.stat-label { font-size: 13px; color: #666; }
.stat-num { font-size: 22px; font-weight: 600; margin-top: 4px; }
.fenye { margin-top: 12px; }
.upload-area { display: flex; flex-wrap: wrap; gap: 8px; }
.img-item { position: relative; width: 80px; height: 80px; border-radius: 4px; overflow: hidden; border: 1px solid #ddd; }
.preview-img { width: 100%; height: 100%; object-fit: cover; }
.img-del { position: absolute; top: 2px; right: 2px; background: rgba(0,0,0,0.5); color: #fff; border-radius: 50%; cursor: pointer; font-size: 14px; padding: 2px; }
.upload-btn { width: 80px; height: 80px; border: 1px dashed #d9d9d9; border-radius: 4px; display: flex; flex-direction: column; align-items: center; justify-content: center; cursor: pointer; background: #fafafa; }
.upload-btn:hover { border-color: #409eff; }
</style>
